import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next'

import _ from 'lodash'
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Form,
    Container,
    Col,
    Row,
} from "reactstrap";

import { CustomInput } from './index'
import { verifyEmail } from 'main_views/components/Form/validations'
import { successToast, errorToast } from 'main_views/components/toast'
import Alert from "main_views/components/alert"
import i18n, { isLangEn } from 'utils/translation/i18n'

function ResetPassword() {

    let { t } = useTranslation()

    let [email, setEmail] = useState('')
    let [loading, setLoading] = useState(false)
    let [error, setError] = useState(false)
    let [successAlert, setAlert] = useState(null)

    useEffect(() => {
        setError(null)
    }, [email])

    const handleResetPass = (e) => {
        e.preventDefault()
        
        let auth = window.firebase.auth()
        
        auth.languageCode = isLangEn()? 'en' : 'ar'

        auth.sendPasswordResetEmail(email.trim()).then(function () {
            
            setAlert({
                show: true,
                isSuccess: true,
                title: 'An Email Was Sent',
                msg: 'Please follow the the link in the email to complete your password reset request.',
                handelConfirm: () => setAlert(null),
            })

        }).catch(function (error) {

            let { message } = error
            setError(message)
            
        });

    }

    return (
        <div className="login-page">
            <Container>
                <Row>

                    <Col className="ml-auto mr-auto" lg="4" md="6">

                        <Form action="handleLogin" className="form" method="POST">

                            <Card className="card-login">

                                <CardHeader>
                                    <CardHeader>
                                        <h3 className="header text-center">{t('forgetPass')}</h3>
                                    </CardHeader>
                                </CardHeader>

                                <CardBody>

                                    <p>{t('forget_pass_txt')}</p>

                                    <CustomInput
                                        title={t('email')}
                                        type='email'
                                        value={email}
                                        placeholder={t('email')}
                                        handelChanges={setEmail}
                                    />

                                    <br />

                                    {!_.isEmpty(error) && (
                                        <p className='text-danger'>{error}</p>
                                    )}

                                    <br />

                                    <Link to='/auth/login'>{t('login')}</Link>

                                    <br />

                                </CardBody>

                                <CardFooter>
                                    <Button
                                        type='submit'
                                        block
                                        className="btn-round mb-3"
                                        color="warning"
                                        onClick={handleResetPass}
                                        disabled={_.isEmpty(email) || !verifyEmail(email)}
                                    >{t(loading ? "loading" : "resetPassword")}</Button>
                                </CardFooter>

                            </Card>
                        </Form>
                    </Col>
                </Row>
            </Container>

                <Alert {...successAlert} />

            <div
                className="full-page-background"
                style={{
                    backgroundImage: `url(${require("assets/img/bg/fabio-mangione.jpg")})`,
                }}
            />

        </div>
    );
}

export default ResetPassword
